import GA4React from 'ga-4-react';
import { fetch } from '../index/move-blocks';

const sendGA = (name) => {
  if (GA4React.isInitialized()) {
    const userId = localStorage.getItem('userId') || Math.random();
    localStorage.setItem('userId', userId);

    const ga4react = new GA4React('G-T5CE4LGSJ6', {
      user_id: userId,
    });
    ga4react.event(name, 'local', 'engagement');
  }
};

function submit({ name, url }, event) {
  const { state } = this;
  if (state.isValid) {
    this.setState({ locationLoading: true }, () => {
      const { email, password } = state.data;
      const body = JSON.stringify({ email, password });
      const options = {
        method: 'POST',
        body,
      };
      fetch(`/api/auth/${url || name}`, options).catch((e) => {
        console.log(e);
        this.setState({
          message: 'Was problem with connection',
          locationLoading: false,
        });
      }).then((r) => {
        if (r) {
          r.json().catch(() => {
            this.setState({
              message: 'Was problem with response',
              locationLoading: false,
            });
          }).then((user) => {
            const { props } = this;
            if (!user.message) {
              sendGA(name);
              props.onLogin({ isAuthenticated: true, user });
              this.setState({ locationLoading: false });
            } else {
              this.setState({
                message: user.message,
                locationLoading: false,
              });
            }
          });
        } else {
          this.setState({
            message: 'Connection error',
            locationLoading: false,
          });
        }
      });
    });
  }
  event.preventDefault();
}

export default submit;
